import { VStack, Icon, HStack, chakra, Text } from "@chakra-ui/react";
import { ReactNode } from "react";
import { FaCloudUploadAlt } from "react-icons/fa";

export default function DropZoneContentContainer({
  children,
}: {
  children?: ReactNode;
}) {
  return (
    <VStack
      spacing={5}
      pt={14}
      pb={16}
      bg="grayV2.100"
      borderRadius="md"
      border="1px solid"
      borderColor="gray.200"
      mb="20px"
    >
      <Icon as={FaCloudUploadAlt} color="brand.blue" fontSize="26px" />
      <HStack>
        <Text>
          <chakra.span color="brand.blue">Click to upload</chakra.span> or drag
          and drop
        </Text>
      </HStack>
      {children ?? (
        <Text fontSize="12px" color="gray.500">
          Format should be .csv with only one column named "
          <Text as="span" color="brand.blue">
            email
          </Text>
        </Text>
      )}
    </VStack>
  );
}
